var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnivariateOperationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 6,
    fill: "#272D55"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 5C18.4122 5 17.3488 5.32257 16.4444 5.92692C15.5399 6.53126 14.8349 7.39025 14.4187 8.39524C14.0024 9.40023 13.8935 10.5061 14.1057 11.573C14.3179 12.6399 14.8417 13.6199 15.6109 14.3891C16.3801 15.1583 17.3601 15.6821 18.427 15.8943C19.4939 16.1065 20.5998 15.9976 21.6048 15.5813C22.6098 15.1651 23.4687 14.4601 24.0731 13.5556C24.6774 12.6512 25 11.5878 25 10.5C25 9.04131 24.4205 7.64236 23.3891 6.61091C22.3576 5.57946 20.9587 5 19.5 5ZM19.5 13.25C18.9561 13.25 18.4244 13.0887 17.9722 12.7865C17.5199 12.4844 17.1675 12.0549 16.9593 11.5524C16.7512 11.0499 16.6967 10.4969 16.8028 9.9635C16.909 9.43005 17.1709 8.94005 17.5555 8.55546C17.9401 8.17086 18.4301 7.90895 18.9635 7.80284C19.497 7.69673 20.0499 7.75119 20.5524 7.95933C21.0549 8.16747 21.4844 8.51995 21.7865 8.97218C22.0887 9.42442 22.25 9.9561 22.25 10.5C22.25 11.2293 21.9603 11.9288 21.4445 12.4445C20.9288 12.9603 20.2293 13.25 19.5 13.25Z",
    fill: "#E3ECFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 33.8333V22.1666",
    stroke: "#E3ECFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1665 28L19.9998 22.1666L25.8332 28",
    stroke: "#E3ECFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnivariateOperationIcon);
export default __webpack_public_path__ + "static/media/UnivariateOperationIcon.cbfd3f197b433ffee0f894209f677c46.svg";
export { ForwardRef as ReactComponent };